export const LocationTypes = {
  ADDITIONALSTOP: 'ADDITIONALSTOP',
  PICKUP: 'PICKUP',
  DROPOFF: 'DROPOFF'
}

export const tripAvailableProductsInitValue = {
  id: 'c394e6bf-b514-4c3e-a7ff-82a3e1da960d',
  name: 'Uber',
  integrationId: '6a8e56b8-914e-4b48-a387-e6ad21d9c00c',
  externalUrl: '',
  pricingId: '8bc735bd-044e-43fd-9100-45f2601af7f8',
  serviceId: 'c44a6c4e-d306-449a-8a55-607d8e29f93d',
  serviceName: 'PSTA DART',
  serviceType: 'PERMANENT',
  serviceBeginsAt: undefined,
  serviceExpiresAt: undefined,
  price: 0,
  fare: 0,
  promoLimit: 0,
  promoFare: 0,
  promoDuration: 'week',
  promoTripCount: 0,
  completedTripCount: 0,
  serviceTripLimit: 2,
  serviceLimitDuration: 'day',
  eta: 0,
  busyDrivers: 0,
  availableDrivers: 0,
  serviceMembershipRequired: false,
  riderHasMembership: true,
  unavailable: false,
  unavailableReason: '',
  viewOption: 'public',
  orgId: 'f01b93dc-3a2f-4245-8dcf-a92275c857bb',
  tripsCount: 1
}

export const feedbackTypeOptions = [
  { label: 'All', value: 'all' },
  { label: 'Positive', value: 'positive' },
  { label: 'Negative', value: 'negative' }
]

export const feedbackUserOption = [
  { label: 'All', value: 'all' },
  { label: 'Rider', value: 'rider' },
  { label: 'Driver', value: 'driver' }
]

export const feedbackStatusOption = [
  { label: 'All', value: 'all' },
  { label: 'Resolved', value: 'resolved' },
  { label: 'Unresolved', value: 'unresolved' }
]

export const driverSessionOrder = ['work_time', 'break', 'standby', 'after_hours']
export const PCA_RIDER_TYPE = 'PCA'
export const FREE_PAYMENT_METHOD = { text: 'Free', value: 'Free' }

export const options = [
  { label: 'REQUESTED', value: 'REQUESTED' },
  { label: 'ACCEPTED', value: 'ACCEPTED' },
  { label: 'CANCELLED', value: 'CANCELLED' },
  { label: 'DRIVER CANCELLED', value: 'DRIVER_CANCELLED' },
  { label: 'RIDER CANCELLED', value: 'RIDER_CANCELLED' },
  { label: 'CANCEL BILLABLE', value: 'CANCEL_BILLABLE' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'BOOKING FAILED', value: 'BOOKING_FAILED' },
  { label: 'INTEGRATION FAILED', value: 'INTEGRATION_FAILED' },
  { label: 'NO RESPONSE OPERATOR', value: 'NO_RESPONSE_OPERATOR' },
  { label: 'COMPLETED', value: 'COMPLETED' },
  { label: 'MANUALLY COMPLETED', value: 'MANUALLY_COMPLETED' },
  { label: 'ARRIVED AT PICK UP', value: 'ARRIVED_AT_PICK_UP' },
  { label: 'DRIVING TO PICK UP', value: 'DRIVING_TO_PICK_UP' },
  { label: 'PICKED UP', value: 'PICKED_UP' },
  { label: 'DRIVING TO DROP OFF', value: 'DRIVING_TO_DROP_OFF' },
  { label: 'ARRIVED AT DROP OFF', value: 'ARRIVED_AT_DROP_OFF' },
  { label: 'SCHEDULED', value: 'SCHEDULED' },
  { label: 'SCHEDULE REQUESTED', value: 'SCHEDULE_REQUESTED' },
  { label: 'SCHEDULE ACCEPTED', value: 'SCHEDULE_ACCEPTED' },
  { label: 'WAITING', value: 'WAITING' },
  { label: 'NO SHOW RIDER', value: 'NO_SHOW_RIDER' },
  { label: 'DISPATCH ASSIGNED DRIVER', value: 'DISPATCH_ASSIGNED_DRIVER' },
  { label: 'WILL CALL', value: 'WILL_CALL' },
  { label: 'EXPIRED', value: 'EXPIRED' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'COMPLETED PENDING PAYMENT', value: 'COMPLETED_PENDING_PAYMENT' }
]

export const initialRiderMessage = 'Search for a Rider using the input.'
export const noResultFoundRiderMessage = 'No riders found matching your criteria.'
export const noResultFoundDriverMessage = 'No drivers found matching your criteria.'
export const initialDriverMessage = 'Loading drivers...'

export const tripColors = {
  GRAY: '#808080',
  RED: '#f5917b',
  ORANGE: '#f8c83d',
  BLUE: '#53c2f0',
  TUSCAN: '#7C3030'
}
export const dateFormat = 'MMMM D, YYYY'



// WEBPACK FOOTER //
// ./src/constants/trip.ts